<template>
  <div class='homePage' id='homePage' ref='homePage'>
    <div style="margin:50vw auto;width: max-content;height:max-content;background: var(--middleBlue)" @click="goto('Login')"
         v-if="!userInfo">Login
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  watch: {},
  async mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    goto (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style lang='less' scoped>
.homePage {
  height: 100dvh;
  overflow: auto;
  position: relative;
  overflow-x: hidden;
  padding-bottom: 5vw;
  background: var(--background);
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue